"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECivility = void 0;
const class_validator_1 = require("class-validator");
const Address_1 = __importDefault(require("./Address"));
const Resource_1 = __importDefault(require("../Resource"));
const classTransformer_1 = require("../classTransformer");
class Contact extends Resource_1.default {
    constructor() {
        super(...arguments);
        this.cell_phone_number = null;
        this.birthdate = null;
        this.created_at = null;
        this.updated_at = null;
    }
}
exports.default = Contact;
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], Contact.prototype, "uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], Contact.prototype, "first_name", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], Contact.prototype, "last_name", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], Contact.prototype, "email", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", Object)
], Contact.prototype, "cell_phone_number", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], Contact.prototype, "civility", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => Address_1.default),
    __metadata("design:type", Address_1.default)
], Contact.prototype, "address", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], Contact.prototype, "birthdate", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], Contact.prototype, "created_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], Contact.prototype, "updated_at", void 0);
var ECivility;
(function (ECivility) {
    ECivility["MALE"] = "MALE";
    ECivility["FEMALE"] = "FEMALE";
    ECivility["OTHERS"] = "OTHERS";
})(ECivility || (exports.ECivility = ECivility = {}));
